<template>
  <!-- <v-list :disabled="loading" > -->
    <v-list :disabled="loading" class="menu-send-test">
      <v-list-item ripple @click="setSelectedTests('ALL')">
        <v-list-item-action class="mr-4">
          <v-icon class="icon-sm" :color="selectedTests.length < items.length ? '' : 'primary'">{{ iconSelectedTests }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="font-sm">Все</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="test in items" :key="test.value" @click="setSelectedTests(test.value)">
        <v-list-item-action class="mr-4">
          <v-icon class="icon-sm" :color="isTestSelected(test) ? 'primary' : ''">
            {{isTestSelected(test) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'}}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="font-sm">
            {{ test.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <!-- <div class="d-flex px-4 py-2">
      <v-btn color="primary" class="mx-auto w-100 btn-disabled-primary" small @click="$emit('apply')">
        Применить
      </v-btn>
    </div>
</v-list> -->
</template>

<script>
export default {
name: 'ListTests',
props: {
  loading: {
    type: Boolean,
    default: false,
  },
  items: Array,
  value: String
},
data: () => ({
  // selectedTests: [],
}),
computed: {
  selectedTests: {
    get() {
      return this.value ? this.value.split(',') : [];
    },
    set(val) {
      // console.log('emit');
      this.$emit('input', val.join(','));
    }
  },
  allTestsSelected() {
    return this.selectedTests.length === this.items.length;
  },
  notAllTestsSelected() {
    return this.selectedTests.length > 0 && !this.allTestsSelected;
  },
  iconSelectedTests() {
    if (this.allTestsSelected) return 'mdi-checkbox-marked';
    if (this.notAllTestsSelected) return 'mdi-close-box';
    return 'mdi-checkbox-blank-outline';
  },

},
methods: {
  isTestSelected(test) {
    return this.selectedTests.some((t) => t === test.value);
  },
  setSelectedTests(val) {
    console.log(val);
    if (val === 'ALL') {
      if (this.selectedTests.length) {
        this.selectedTests = [];
      } else {
        this.selectedTests = this.items.map(el => el.value);
      }
      return;
    }

    if (this.selectedTests.some((t) => t === val)) {
      this.selectedTests = this.selectedTests.filter((t) => t !== val);
    } else {
      this.selectedTests = [...this.selectedTests, val];
    }
    console.log(this.selectedTests);
  },

},
};
</script>

<style >
.menu-send-test {
max-height: 350px;
overflow-y: auto;
}
</style>
